import obra from './obra'
import cadastros from './cadastros'

export default [
  ...cadastros,
  ...obra,
];
